import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { Urls } from 'constants/constants';

import Overlay from 'store/models/Overlay';
import Channel, { selectChannels } from 'store/models/Channel';
import RouteState, { selectRoute } from 'store/RouteState';

export const OverlayRedirect = ({...props }) => {
  let dispatch = useDispatch();
  let { channelId, query, data } = useSelector(s => ({
    channelId: selectChannels(s) |> _.values |> _.first |> #?._id,
    query: selectRoute(s)?.query,
    data: selectRoute(s)?.data,
  }));
  useEffect(() => {
    (async function fetchData() {
      if(!channelId) {
        let response = await dispatch(Channel.actions.fetchChannels());
        channelId = response.body?.channels?.[0]?._id;
      }
      dispatch(RouteState.actions.navigate(Urls.SLIDESHOW_EDIT_ROUTE, { channelId }, query, data)); //
    })();
  }, [])
  return null;
}
export default OverlayRedirect;
